/**
 * Script para atualizar dinamicamente o badge do carrinho na barra superior
 */
class TopHeaderBar {
  constructor() {
    this.cartBadge = document.querySelector('.top-header-bar__cart-badge');
    this.cartLink = document.querySelector('#top-header-cart');
    this.init();
  }

  init() {
    // Atualiza o badge quando a página carrega
    this.updateCartBadge();

    // Escuta eventos de atualização do carrinho
    document.addEventListener('cart:updated', () => {
      this.updateCartBadge();
    });

    // Escuta eventos do Shopify
    document.addEventListener('shopify:cart:updated', () => {
      this.updateCartBadge();
    });

    // Fallback: verifica mudanças no DOM do carrinho principal
    this.observeCartChanges();
  }

  updateCartBadge() {
    // Tenta pegar o contador do carrinho principal do header
    const mainCartBadge = document.querySelector('#cart-icon-bubble .cart-count-bubble span');
    
    if (mainCartBadge) {
      const count = parseInt(mainCartBadge.textContent.trim()) || 0;
      this.setCartCount(count);
    } else {
      // Se não encontrar, faz uma requisição para obter o contador
      this.fetchCartCount();
    }
  }

  async fetchCartCount() {
    try {
      const response = await fetch('/cart.js');
      if (response.ok) {
        const cart = await response.json();
        this.setCartCount(cart.item_count || 0);
      }
    } catch (error) {
      console.error('Erro ao buscar contador do carrinho:', error);
    }
  }

  setCartCount(count) {
    if (!this.cartBadge) {
      // Cria o badge se não existir
      if (this.cartLink && count > 0) {
        this.cartBadge = document.createElement('span');
        this.cartBadge.className = 'top-header-bar__cart-badge';
        this.cartLink.appendChild(this.cartBadge);
      } else {
        return;
      }
    }

    if (count > 0) {
      this.cartBadge.textContent = count < 100 ? count : '99+';
      this.cartBadge.style.display = 'flex';
    } else {
      this.cartBadge.style.display = 'none';
    }
  }

  observeCartChanges() {
    // Observa mudanças no badge do carrinho principal
    const mainCart = document.querySelector('#cart-icon-bubble');
    if (mainCart) {
      const observer = new MutationObserver(() => {
        this.updateCartBadge();
      });

      observer.observe(mainCart, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }
}

// Inicializa quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new TopHeaderBar();
  });
} else {
  new TopHeaderBar();
}
